"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedFilterRuleSchema = exports.BaseFilterRuleSchema = void 0;
const zod_1 = require("zod");
const filterCriteria_1 = require("./filterCriteria");
const singleFilterRule_1 = require("./singleFilterRule");
exports.BaseFilterRuleSchema = zod_1.z.object({
    comment: zod_1.z.string().optional(),
    criteria: filterCriteria_1.FilterCriteriaSchema,
});
/**
 * Zod validator for a NestedFilterRule
 */
exports.NestedFilterRuleSchema = exports.BaseFilterRuleSchema.extend({
    rules: zod_1.z.array(zod_1.z.lazy(() => singleFilterRule_1.SingleFilterRuleSchema.or(exports.NestedFilterRuleSchema))),
});
//# sourceMappingURL=nestedFilterRule.js.map